import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { SNItem } from './snitem';

@RegisterItem()
export class CBIPMPP extends SNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CBIP.MPP';
    }

    public clone(): any {
        return new CBIPMPP();
    }
}
